module.exports = __webpack_public_path__ + "img/suppliercheck-logo-white.dd03dedd.png";